import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { updateUserValidation } from "../../utils/validation";
import * as api from "../../redux/api";
import { toast } from "react-toastify";
import { isYupError, parseYupError } from "../../utils/Yup";
import Loader from "../loaders/Loader";
import DesktopCountryForm from "../Forms/DesktopCountryForm";
import { Country, State, City } from "country-state-city";

const initialState = {
  firstname: "",
  lastname: "",
  email: "",
  address_line_1: "",
  address_line_2: "",
  mobile: "",
  password: "",
  referralCode: ""
};

const EditUser = ({ handleClose, open, user, data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState(initialState);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [dialCode, setDialCode] = useState("91");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [selectedCity, setSelectedCity] = useState("");
  const [countryName, setCountryName] = useState("India");
  const [stateName, setStateName] = useState("");

  useEffect(() => {
    if (
      user &&
      Object.keys(user).length > 0 &&
      data &&
      Object.keys(data).length > 0
    ) {
      setForm((prevForm) => ({
        ...prevForm,
        firstname: data?.firstname,
        lastname: data?.lastname,
        email: data?.email,
        address_line_1: data?.meta?.address_line_1,
        address_line_2: data?.meta?.address_line_2,
        mobile: data?.mobile?.replace(data?.dialCode, ""),
        referralCode: user?.meta?.referralCode
      }));
      const country = Country.getAllCountries().find(
        (c) => c.name === data?.country
      );
      const statesList = State.getStatesOfCountry(country?.isoCode);
      const state = statesList.find((s) => s.name === data?.meta?.state);
      const citiesList = City.getCitiesOfState(
        country?.isoCode,
        state?.isoCode
      );
      const city = citiesList.find((s) => s.name === data?.meta?.city);
      setCities(citiesList);
      setSelectedCity(city?.name);
      setSelectedState(state?.isoCode);
      setStateName(state?.name);
      setCountryName(country?.name);
      setSelectedCountry(country?.isoCode);
      setDialCode(data?.dialCode.replace("+", ""));
      setSelectedCity(data?.meta?.city);
      setStateName(data?.meta?.state);
    }
  }, [user, data, states]);

  const handleCloseModal = () => {
    handleClose();
    setForm((prevForm) => ({
      ...initialState,
      referralCode: prevForm.referralCode
    }));
    setFormError(initialState);
    setStateName("");
    selectedCity("");
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };
  console.log(formError, "formError");
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    try {
      setIsLoading(true);
      await updateUserValidation.validate(form, {
        abortEarly: false
      });
      if (!selectedState) {
        setFormError({
          ...formError,
          state: "Please select a state"
        });
        return;
      }
      if (!selectedCity) {
        setFormError({
          ...formError,
          city: "Please select a city"
        });
        return;
      }
      const payload = {
        ...form,
        userId: data?.id,
        dialCode: "+" + dialCode,
        mobile: "+" + dialCode + form.mobile,
        addedBy: "admin",
        state: stateName,
        city: selectedCity,
        country: countryName
      };
      const res = await api.updateUser(payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("Updated Successfully");
        handleCloseModal();
      } else {
        toast.error(res?.error?.message);
      }
    } catch (error) {
      if (isYupError(error)) {
        setFormError(parseYupError(error));
        setIsLoading(false);
      } else if (
        error.response &&
        error.response.data &&
        Array.isArray(error.response.data.message)
      ) {
        toast.error(error.response.data.message[0]);
      } else {
        console.log(error, "error");
        toast.error(error.response.data.message);
        setIsLoading(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setSelectedCountry(countryCode);
    setSelectedState("");
    setSelectedCity("");
    setCities([]);
    const country = Country.getAllCountries().find(
      (c) => c.isoCode === countryCode
    );
    setCountryName(country.name);
    setDialCode(country?.phonecode);
    if (country) {
      const statesList = State.getStatesOfCountry(countryCode);
      setStates(statesList);
    } else {
      setStates([]);
    }
  };

  const handleStateChange = (e) => {
    const stateCode = e.target.value;
    setSelectedState(stateCode);
    setSelectedCity("");

    const state = states.find((s) => s.isoCode === stateCode);
    setStateName(state?.name);
    if (state) {
      setFormError((prev) => ({ ...prev, state: "" }));
      const citiesList = City.getCitiesOfState(selectedCountry, stateCode);
      setCities(citiesList);
    } else {
      setCities([]);
    }
  };
  const handleCityChange = (e) => {
    setSelectedCity(e.target.value);
    if (e.target.value) {
      setFormError((prev) => ({ ...prev, city: "" }));
    }
  };
  useEffect(() => {
    const statesList = State.getStatesOfCountry("IN");
    setStates(statesList);

    const country = Country.getAllCountries().find((c) => c.isoCode === "IN");
    if (country) {
      setCountryName(country.name);
    }
  }, []);
  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseModal}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {" "}
          <h4 className=" text-center">Edit User</h4>
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent dividers={"paper"}>
            <div className="relative">
              <div className="lg:grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block">First Name</label>
                  <input
                    type="text"
                    placeholder="Enter First Name"
                    autoComplete="off"
                    name="firstname"
                    value={form.firstname}
                    onKeyDown={(e) => {
                      if (/[^a-zA-Z ]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={handleChange}
                    className="text-input text-black text-12 lg:text-14 border"
                  />
                  {formError.firstname && (
                    <div className="form-eror">{formError.firstname}</div>
                  )}
                </div>
                <div className="mb-3 lg:mb-0">
                  <label className="mb-2 block">Last Name</label>
                  <input
                    type="text"
                    placeholder="Enter Last Name"
                    name="lastname"
                    value={form.lastname}
                    onKeyDown={(e) => {
                      if (/[^a-zA-Z ]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    autoComplete="off"
                    onChange={handleChange}
                    className="text-input text-black border-[#BEBEBE] text-12 lg:text-14 border"
                  />
                  {formError.lastname && (
                    <div className="form-eror">{formError.lastname}</div>
                  )}
                </div>
                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block">Email Address</label>
                  <input
                    type="text"
                    placeholder="Enter Email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    autoComplete="off"
                    className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                  />
                  {formError.email && (
                    <div className="form-eror">{formError.email}</div>
                  )}
                </div>

                <DesktopCountryForm
                  errorMsg={formError}
                  handleCityChange={handleCityChange}
                  selectedState={selectedState}
                  cities={cities}
                  handleCountryChange={handleCountryChange}
                  selectedCountry={selectedCountry}
                  Country={Country}
                  handleStateChange={handleStateChange}
                  states={states}
                  selectedCity={selectedCity}
                />

                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block">Address Line 1</label>
                  <input
                    type="text"
                    placeholder="House No., Street No...."
                    name="address_line_1"
                    autoComplete="off"
                    maxlength="100"
                    value={form.address_line_1}
                    onChange={handleChange}
                    className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                  />
                  {formError.address_line_1 && (
                    <div className="form-eror">{formError.address_line_1}</div>
                  )}
                </div>
                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block">Address Line 2</label>
                  <input
                    type="text"
                    placeholder="Landmark , Other Details....."
                    name="address_line_2"
                    autoComplete="off"
                    maxlength="100"
                    value={form.address_line_2}
                    onChange={handleChange}
                    className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                  />
                  {/* {formError.address_line_2 && (
                    <div className="form-eror">{formError.address_line_2}</div>
                  )} */}
                </div>

                <div className="input_field mb-3 lg:mb-0">
                  <label className="mb-2 block">Mobile Number</label>
                  <div className="relative">
                    <span className="cursor-pointer absolute left-[1px] top-[2px] py-[16.4px] lg:py-[11.4px] px-[6px]  border border-r-black border-y-0 border-l-0 min-w-[50px] h-[45px] flex items-center justify-center">
                      +{dialCode}
                    </span>
                    <input
                      type="text"
                      placeholder="Enter Mobile Number"
                      name="mobile"
                      value={form.mobile}
                      onChange={handleChange}
                      autoComplete="off"
                      className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14 pl-[60px]"
                    />

                    {formError.mobile && (
                      <div className="form-eror">{formError.mobile}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <button
              type="button"
              onClick={handleCloseModal}
              className={`btn btn-danger `}
            >
              Close
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className={`btn btn-primary ${
                isLoading
                  ? "bg-red-500 border-red-500 opacity-50 disabled:pointer-events-none"
                  : ""
              }`}
            >
              {isLoading ? <Loader /> : "Update"}
            </button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default EditUser;
